import { getCounterpartyColumns } from 'utils/helpers/counterPartyHelper';
import { TranslateFunction } from 'utils/interfaces/Translations';

import { BaseCounterparties } from './BaseCounterparties';

export const CompaniesCounterparties = () => {
  const getColumnsWithHelpers = (translate: TranslateFunction) =>
    getCounterpartyColumns(translate);

  return (
    <BaseCounterparties getColumns={getColumnsWithHelpers} isFilterable />
  );
};
